// CountryFlag.js - Fixed version
const countryFlagMap = {
    "Aruba": "/countries/Aruba.png",
    "ABW": "/countries/ABW.png",
    "Afghanistan": "/countries/Afghanistan.png",
    "AFG": "/countries/AFG.png",
    "Angola": "/countries/Angola.png",
    "AGO": "/countries/AGO.png",
    "Anguilla": "/countries/Anguilla.png",
    "AIA": "/countries/AIA.png",
    "Albania": "/countries/Albania.png",
    "ALB": "/countries/ALB.png",
    "Andorra": "/countries/Andorra.png",
    "AND": "/countries/AND.png",
    "United Arab Emirates": "/countries/United Arab Emirates.png",
    "ARE": "/countries/ARE.png",
    "Argentina": "/countries/Argentina.png",
    "ARG": "/countries/ARG.png",
    "Armenia": "/countries/Armenia.png",
    "ARM": "/countries/ARM.png",
    "American Samoa": "/countries/American Samoa.png",
    "ASM": "/countries/ASM.png",
    "French Southern Territories": "/countries/French Southern Territories.png",
    "ATF": "/countries/ATF.png",
    "Antigua and Barbuda": "/countries/Antigua and Barbuda.png",
    "ATG": "/countries/ATG.png",
    "Australia": "/countries/Australia.png",
    "AUS": "/countries/AUS.png",
    "Austria": "/countries/Austria.png",
    "AUT": "/countries/AUT.png",
    "Azerbaijan": "/countries/Azerbaijan.png",
    "AZE": "/countries/AZE.png",
    "Burundi": "/countries/Burundi.png",
    "BDI": "/countries/BDI.png",
    "Belgium": "/countries/Belgium.png",
    "BEL": "/countries/BEL.png",
    "Benin": "/countries/Benin.png",
    "BEN": "/countries/BEN.png",
    "Burkina Faso": "/countries/Burkina Faso.png",
    "BFA": "/countries/BFA.png",
    "Bangladesh": "/countries/Bangladesh.png",
    "BGD": "/countries/BGD.png",
    "Bulgaria": "/countries/Bulgaria.png",
    "BGR": "/countries/BGR.png",
    "Bahrain": "/countries/Bahrain.png",
    "BHR": "/countries/BHR.png",
    "Bahamas": "/countries/Bahamas.png",
    "BHS": "/countries/BHS.png",
    "Bosnia and Herzegovina": "/countries/Bosnia and Herzegovina.png",
    "BIH": "/countries/BIH.png",
    "Belarus": "/countries/Belarus.png",
    "BLR": "/countries/BLR.png",
    "Belize": "/countries/Belize.png",
    "BLZ": "/countries/BLZ.png",
    "Bermuda": "/countries/Bermuda.png",
    "BMU": "/countries/BMU.png",
    "Bolivia, Plurinational State of": "/countries/Bolivia, Plurinational State of.png",
    "BOL": "/countries/BOL.png",
    "Brazil": "/countries/Brazil.png",
    "BRA": "/countries/BRA.png",
    "Barbados": "/countries/Barbados.png",
    "BRB": "/countries/BRB.png",
    "Brunei Darussalam": "/countries/Brunei Darussalam.png",
    "BRN": "/countries/BRN.png",
    "Bhutan": "/countries/Bhutan.png",
    "BTN": "/countries/BTN.png",
    "Bouvet Island": "/countries/Bouvet Island.png",
    "BVT": "/countries/BVT.png",
    "Botswana": "/countries/Botswana.png",
    "BWA": "/countries/BWA.png",
    "Central African Republic": "/countries/Central African Republic.png",
    "CAF": "/countries/CAF.png",
    "Canada": "/countries/Canada.png",
    "CAN": "/countries/CAN.png",
    "Cocos (Keeling) Islands": "/countries/Cocos (Keeling) Islands.png",
    "CCK": "/countries/CCK.png",
    "Switzerland": "/countries/Switzerland.png",
    "CHE": "/countries/CHE.png",
    "Chile": "/countries/Chile.png",
    "CHL": "/countries/CHL.png",
    "China": "/countries/China.png",
    "CHN": "/countries/CHN.png",
    "Côte d'Ivoire": "/countries/Côte d'Ivoire.png",
    "CIV": "/countries/CIV.png",
    "Cameroon": "/countries/Cameroon.png",
    "CMR": "/countries/CMR.png",
    "Congo, The Democratic Republic of the": "/countries/Congo, The Democratic Republic of the.png",
    "COD": "/countries/COD.png",
    "Congo": "/countries/Congo.png",
    "COG": "/countries/COG.png",
    "Cook Islands": "/countries/Cook Islands.png",
    "COK": "/countries/COK.png",
    "Colombia": "/countries/Colombia.png",
    "COL": "/countries/COL.png",
    "Comoros": "/countries/Comoros.png",
    "COM": "/countries/COM.png",
    "Cabo Verde": "/countries/Cabo Verde.png",
    "CPV": "/countries/CPV.png",
    "Costa Rica": "/countries/Costa Rica.png",
    "CRI": "/countries/CRI.png",
    "Cuba": "/countries/Cuba.png",
    "CUB": "/countries/CUB.png",
    "Curaçao": "/countries/Curaçao.png",
    "CUW": "/countries/CUW.png",
    "Christmas Island": "/countries/Christmas Island.png",
    "CXR": "/countries/CXR.png",
    "Cayman Islands": "/countries/Cayman Islands.png",
    "CYM": "/countries/CYM.png",
    "Cyprus": "/countries/Cyprus.png",
    "CYP": "/countries/CYP.png",
    "Czechia": "/countries/Czechia.png",
    "CZE": "/countries/CZE.png",
    "Germany": "/countries/Germany.png",
    "DEU": "/countries/DEU.png",
    "Djibouti": "/countries/Djibouti.png",
    "DJI": "/countries/DJI.png",
    "Dominica": "/countries/Dominica.png",
    "DMA": "/countries/DMA.png",
    "Denmark": "/countries/Denmark.png",
    "DNK": "/countries/DNK.png",
    "Dominican Republic": "/countries/Dominican Republic.png",
    "DOM": "/countries/DOM.png",
    "Algeria": "/countries/Algeria.png",
    "DZA": "/countries/DZA.png",
    "Ecuador": "/countries/Ecuador.png",
    "ECU": "/countries/ECU.png",
    "Egypt": "/countries/Egypt.png",
    "EGY": "/countries/EGY.png",
    "Eritrea": "/countries/Eritrea.png",
    "ERI": "/countries/ERI.png",
    "Spain": "/countries/Spain.png",
    "ESP": "/countries/ESP.png",
    "Estonia": "/countries/Estonia.png",
    "EST": "/countries/EST.png",
    "Ethiopia": "/countries/Ethiopia.png",
    "ETH": "/countries/ETH.png",
    "Finland": "/countries/Finland.png",
    "FIN": "/countries/FIN.png",
    "Fiji": "/countries/Fiji.png",
    "FJI": "/countries/FJI.png",
    "Falkland Islands (Malvinas)": "/countries/Falkland Islands (Malvinas).png",
    "FLK": "/countries/FLK.png",
    "France": "/countries/France.png",
    "FRA": "/countries/FRA.png",
    "Faroe Islands": "/countries/Faroe Islands.png",
    "FRO": "/countries/FRO.png",
    "Micronesia, Federated States of": "/countries/Micronesia, Federated States of.png",
    "FSM": "/countries/FSM.png",
    "Gabon": "/countries/Gabon.png",
    "GAB": "/countries/GAB.png",
    "United Kingdom": "/countries/United Kingdom.png",
    "GBR": "/countries/GBR.png",
    "Georgia": "/countries/Georgia.png",
    "GEO": "/countries/GEO.png",
    "Ghana": "/countries/Ghana.png",
    "GHA": "/countries/GHA.png",
    "Gibraltar": "/countries/Gibraltar.png",
    "GIB": "/countries/GIB.png",
    "Guinea": "/countries/Guinea.png",
    "GIN": "/countries/GIN.png",
    "Guadeloupe": "/countries/Guadeloupe.png",
    "GLP": "/countries/GLP.png",
    "Gambia": "/countries/Gambia.png",
    "GMB": "/countries/GMB.png",
    "Guinea-Bissau": "/countries/Guinea-Bissau.png",
    "GNB": "/countries/GNB.png",
    "Equatorial Guinea": "/countries/Equatorial Guinea.png",
    "GNQ": "/countries/GNQ.png",
    "Greece": "/countries/Greece.png",
    "GRC": "/countries/GRC.png",
    "Grenada": "/countries/Grenada.png",
    "GRD": "/countries/GRD.png",
    "Greenland": "/countries/Greenland.png",
    "GRL": "/countries/GRL.png",
    "Guatemala": "/countries/Guatemala.png",
    "GTM": "/countries/GTM.png",
    "French Guiana": "/countries/French Guiana.png",
    "GUF": "/countries/GUF.png",
    "Guam": "/countries/Guam.png",
    "GUM": "/countries/GUM.png",
    "Guyana": "/countries/Guyana.png",
    "GUY": "/countries/GUY.png",
    "Hong Kong": "/countries/Hong Kong.png",
    "HKG": "/countries/HKG.png",
    "Heard Island and McDonald Islands": "/countries/Heard Island and McDonald Islands.png",
    "HMD": "/countries/HMD.png",
    "Honduras": "/countries/Honduras.png",
    "HND": "/countries/HND.png",
    "Croatia": "/countries/Croatia.png",
    "HRV": "/countries/HRV.png",
    "Haiti": "/countries/Haiti.png",
    "HTI": "/countries/HTI.png",
    "Hungary": "/countries/Hungary.png",
    "HUN": "/countries/HUN.png",
    "Indonesia": "/countries/Indonesia.png",
    "IDN": "/countries/IDN.png",
    "Isle of Man": "/countries/Isle of Man.png",
    "IMN": "/countries/IMN.png",
    "India": "/countries/India.png",
    "IND": "/countries/IND.png",
    "British Indian Ocean Territory": "/countries/British Indian Ocean Territory.png",
    "IOT": "/countries/IOT.png",
    "Ireland": "/countries/Ireland.png",
    "IRL": "/countries/IRL.png",
    "Iran, Islamic Republic of": "/countries/Iran, Islamic Republic of.png",
    "IRN": "/countries/IRN.png",
    "Iraq": "/countries/Iraq.png",
    "IRQ": "/countries/IRQ.png",
    "Iceland": "/countries/Iceland.png",
    "ISL": "/countries/ISL.png",
    "Israel": "/countries/Israel.png",
    "ISR": "/countries/ISR.png",
    "Italy": "/countries/Italy.png",
    "ITA": "/countries/ITA.png",
    "Jamaica": "/countries/Jamaica.png",
    "JAM": "/countries/JAM.png",
    "Jordan": "/countries/Jordan.png",
    "JOR": "/countries/JOR.png",
    "Japan": "/countries/Japan.png",
    "JPN": "/countries/JPN.png",
    "Kazakhstan": "/countries/Kazakhstan.png",
    "KAZ": "/countries/KAZ.png",
    "Kenya": "/countries/Kenya.png",
    "KEN": "/countries/KEN.png",
    "Kyrgyzstan": "/countries/Kyrgyzstan.png",
    "KGZ": "/countries/KGZ.png",
    "Cambodia": "/countries/Cambodia.png",
    "KHM": "/countries/KHM.png",
    "Kiribati": "/countries/Kiribati.png",
    "KIR": "/countries/KIR.png",
    "Saint Kitts and Nevis": "/countries/Saint Kitts and Nevis.png",
    "KNA": "/countries/KNA.png",
    "Korea, Republic of": "/countries/Korea, Republic of.png",
    "KOR": "/countries/KOR.png",
    "Kuwait": "/countries/Kuwait.png",
    "KWT": "/countries/KWT.png",
    "Lao People's Democratic Republic": "/countries/Lao People's Democratic Republic.png",
    "LAO": "/countries/LAO.png",
    "Lebanon": "/countries/Lebanon.png",
    "LBN": "/countries/LBN.png",
    "Liberia": "/countries/Liberia.png",
    "LBR": "/countries/LBR.png",
    "Libya": "/countries/Libya.png",
    "LBY": "/countries/LBY.png",
    "Saint Lucia": "/countries/Saint Lucia.png",
    "LCA": "/countries/LCA.png",
    "Liechtenstein": "/countries/Liechtenstein.png",
    "LIE": "/countries/LIE.png",
    "Sri Lanka": "/countries/Sri Lanka.png",
    "LKA": "/countries/LKA.png",
    "Lesotho": "/countries/Lesotho.png",
    "LSO": "/countries/LSO.png",
    "Lithuania": "/countries/Lithuania.png",
    "LTU": "/countries/LTU.png",
    "Luxembourg": "/countries/Luxembourg.png",
    "LUX": "/countries/LUX.png",
    "Latvia": "/countries/Latvia.png",
    "LVA": "/countries/LVA.png",
    "Macao": "/countries/Macao.png",
    "MAC": "/countries/MAC.png",
    "Morocco": "/countries/Morocco.png",
    "MAR": "/countries/MAR.png",
    "Monaco": "/countries/Monaco.png",
    "MCO": "/countries/MCO.png",
    "Moldova, Republic of": "/countries/Moldova, Republic of.png",
    "MDA": "/countries/MDA.png",
    "Madagascar": "/countries/Madagascar.png",
    "MDG": "/countries/MDG.png",
    "Maldives": "/countries/Maldives.png",
    "MDV": "/countries/MDV.png",
    "Mexico": "/countries/Mexico.png",
    "MEX": "/countries/MEX.png",
    "Marshall Islands": "/countries/Marshall Islands.png",
    "MHL": "/countries/MHL.png",
    "North Macedonia": "/countries/North Macedonia.png",
    "MKD": "/countries/MKD.png",
    "Mali": "/countries/Mali.png",
    "MLI": "/countries/MLI.png",
    "Malta": "/countries/Malta.png",
    "MLT": "/countries/MLT.png",
    "Myanmar": "/countries/Myanmar.png",
    "MMR": "/countries/MMR.png",
    "Montenegro": "/countries/Montenegro.png",
    "MNE": "/countries/MNE.png",
    "Mongolia": "/countries/Mongolia.png",
    "MNG": "/countries/MNG.png",
    "Northern Mariana Islands": "/countries/Northern Mariana Islands.png",
    "MNP": "/countries/MNP.png",
    "Mozambique": "/countries/Mozambique.png",
    "MOZ": "/countries/MOZ.png",
    "Mauritania": "/countries/Mauritania.png",
    "MRT": "/countries/MRT.png",
    "Montserrat": "/countries/Montserrat.png",
    "MSR": "/countries/MSR.png",
    "Martinique": "/countries/Martinique.png",
    "MTQ": "/countries/MTQ.png",
    "Mauritius": "/countries/Mauritius.png",
    "MUS": "/countries/MUS.png",
    "Malawi": "/countries/Malawi.png",
    "MWI": "/countries/MWI.png",
    "Malaysia": "/countries/Malaysia.png",
    "MYS": "/countries/MYS.png",
    "Mayotte": "/countries/Mayotte.png",
    "MYT": "/countries/MYT.png",
    "Namibia": "/countries/Namibia.png",
    "NAM": "/countries/NAM.png",
    "New Caledonia": "/countries/New Caledonia.png",
    "NCL": "/countries/NCL.png",
    "Niger": "/countries/Niger.png",
    "NER": "/countries/NER.png",
    "Norfolk Island": "/countries/Norfolk Island.png",
    "NFK": "/countries/NFK.png",
    "Nigeria": "/countries/Nigeria.png",
    "NGA": "/countries/NGA.png",
    "Nicaragua": "/countries/Nicaragua.png",
    "NIC": "/countries/NIC.png",
    "Niue": "/countries/Niue.png",
    "NIU": "/countries/NIU.png",
    "Netherlands": "/countries/Netherlands.png",
    "NLD": "/countries/NLD.png",
    "Norway": "/countries/Norway.png",
    "NOR": "/countries/NOR.png",
    "Nepal": "/countries/Nepal.png",
    "NPL": "/countries/NPL.png",
    "Nauru": "/countries/Nauru.png",
    "NRU": "/countries/NRU.png",
    "New Zealand": "/countries/New Zealand.png",
    "NZL": "/countries/NZL.png",
    "Oman": "/countries/Oman.png",
    "OMN": "/countries/OMN.png",
    "Pakistan": "/countries/Pakistan.png",
    "PAK": "/countries/PAK.png",
    "Panama": "/countries/Panama.png",
    "PAN": "/countries/PAN.png",
    "Pitcairn": "/countries/Pitcairn.png",
    "PCN": "/countries/PCN.png",
    "Peru": "/countries/Peru.png",
    "PER": "/countries/PER.png",
    "Philippines": "/countries/Philippines.png",
    "PHL": "/countries/PHL.png",
    "Palau": "/countries/Palau.png",
    "PLW": "/countries/PLW.png",
    "Papua New Guinea": "/countries/Papua New Guinea.png",
    "PNG": "/countries/PNG.png",
    "Poland": "/countries/Poland.png",
    "POL": "/countries/POL.png",
    "Puerto Rico": "/countries/Puerto Rico.png",
    "PRI": "/countries/PRI.png",
    "Korea, Democratic People's Republic of": "/countries/Korea, Democratic People's Republic of.png",
    "PRK": "/countries/PRK.png",
    "Portugal": "/countries/Portugal.png",
    "PRT": "/countries/PRT.png",
    "Paraguay": "/countries/Paraguay.png",
    "PRY": "/countries/PRY.png",
    "Palestine, State of": "/countries/Palestine, State of.png",
    "PSE": "/countries/PSE.png",
    "French Polynesia": "/countries/French Polynesia.png",
    "PYF": "/countries/PYF.png",
    "Qatar": "/countries/Qatar.png",
    "QAT": "/countries/QAT.png",
    "Réunion": "/countries/Réunion.png",
    "REU": "/countries/REU.png",
    "Romania": "/countries/Romania.png",
    "ROU": "/countries/ROU.png",
    "Russian Federation": "/countries/Russian Federation.png",
    "RUS": "/countries/RUS.png",
    "Rwanda": "/countries/Rwanda.png",
    "RWA": "/countries/RWA.png",
    "Saudi Arabia": "/countries/Saudi Arabia.png",
    "SAU": "/countries/SAU.png",
    "Sudan": "/countries/Sudan.png",
    "SDN": "/countries/SDN.png",
    "Senegal": "/countries/Senegal.png",
    "SEN": "/countries/SEN.png",
    "Singapore": "/countries/Singapore.png",
    "SGP": "/countries/SGP.png",
    "South Georgia and the South Sandwich Islands": "/countries/South Georgia and the South Sandwich Islands.png",
    "SGS": "/countries/SGS.png",
    "Saint Helena, Ascension and Tristan da Cunha": "/countries/Saint Helena, Ascension and Tristan da Cunha.png",
    "SHN": "/countries/SHN.png",
    "Solomon Islands": "/countries/Solomon Islands.png",
    "SLB": "/countries/SLB.png",
    "Sierra Leone": "/countries/Sierra Leone.png",
    "SLE": "/countries/SLE.png",
    "El Salvador": "/countries/El Salvador.png",
    "SLV": "/countries/SLV.png",
    "San Marino": "/countries/San Marino.png",
    "SMR": "/countries/SMR.png",
    "Somalia": "/countries/Somalia.png",
    "SOM": "/countries/SOM.png",
    "Saint Pierre and Miquelon": "/countries/Saint Pierre and Miquelon.png",
    "SPM": "/countries/SPM.png",
    "Serbia": "/countries/Serbia.png",
    "SRB": "/countries/SRB.png",
    "Sao Tome and Principe": "/countries/Sao Tome and Principe.png",
    "STP": "/countries/STP.png",
    "Suriname": "/countries/Suriname.png",
    "SUR": "/countries/SUR.png",
    "Slovakia": "/countries/Slovakia.png",
    "SVK": "/countries/SVK.png",
    "Slovenia": "/countries/Slovenia.png",
    "SVN": "/countries/SVN.png",
    "Sweden": "/countries/Sweden.png",
    "SWE": "/countries/SWE.png",
    "Eswatini": "/countries/Eswatini.png",
    "SWZ": "/countries/SWZ.png",
    "Sint Maarten (Dutch part)": "/countries/Sint Maarten (Dutch part).png",
    "SXM": "/countries/SXM.png",
    "Seychelles": "/countries/Seychelles.png",
    "SYC": "/countries/SYC.png",
    "Syrian Arab Republic": "/countries/Syrian Arab Republic.png",
    "SYR": "/countries/SYR.png",
    "Turks and Caicos Islands": "/countries/Turks and Caicos Islands.png",
    "TCA": "/countries/TCA.png",
    "Chad": "/countries/Chad.png",
    "TCD": "/countries/TCD.png",
    "Togo": "/countries/Togo.png",
    "TGO": "/countries/TGO.png",
    "Thailand": "/countries/Thailand.png",
    "THA": "/countries/THA.png",
    "Tajikistan": "/countries/Tajikistan.png",
    "TJK": "/countries/TJK.png",
    "Tokelau": "/countries/Tokelau.png",
    "TKL": "/countries/TKL.png",
    "Turkmenistan": "/countries/Turkmenistan.png",
    "TKM": "/countries/TKM.png",
    "Timor-Leste": "/countries/Timor-Leste.png",
    "TLS": "/countries/TLS.png",
    "Tonga": "/countries/Tonga.png",
    "TON": "/countries/TON.png",
    "Trinidad and Tobago": "/countries/Trinidad and Tobago.png",
    "TTO": "/countries/TTO.png",
    "Tunisia": "/countries/Tunisia.png",
    "TUN": "/countries/TUN.png",
    "Türkiye": "/countries/Türkiye.png",
    "TUR": "/countries/TUR.png",
    "Tuvalu": "/countries/Tuvalu.png",
    "TUV": "/countries/TUV.png",
    "Taiwan, Province of China": "/countries/Taiwan, Province of China.png",
    "TWN": "/countries/TWN.png",
    "Tanzania, United Republic of": "/countries/Tanzania, United Republic of.png",
    "TZA": "/countries/TZA.png",
    "Uganda": "/countries/Uganda.png",
    "UGA": "/countries/UGA.png",
    "Ukraine": "/countries/Ukraine.png",
    "UKR": "/countries/UKR.png",
    "Uruguay": "/countries/Uruguay.png",
    "URY": "/countries/URY.png",
    "United States of America": "/countries/United States of America.png",
    "USA": "/countries/USA.png",
    "Uzbekistan": "/countries/Uzbekistan.png",
    "UZB": "/countries/UZB.png",
    "Holy See (Vatican City State)": "/countries/Holy See (Vatican City State).png",
    "VAT": "/countries/VAT.png",
    "Saint Vincent and the Grenadines": "/countries/Saint Vincent and the Grenadines.png",
    "VCT": "/countries/VCT.png",
    "Venezuela, Bolivarian Republic of": "/countries/Venezuela, Bolivarian Republic of.png",
    "VEN": "/countries/VEN.png",
    "Virgin Islands, British": "/countries/Virgin Islands, British.png",
    "VGB": "/countries/VGB.png",
    "Virgin Islands, U.S.": "/countries/Virgin Islands, U.S..png",
    "VIR": "/countries/VIR.png",
    "Viet Nam": "/countries/Viet Nam.png",
    "VNM": "/countries/VNM.png",
    "Vanuatu": "/countries/Vanuatu.png",
    "VUT": "/countries/VUT.png",
    "Wallis and Futuna": "/countries/Wallis and Futuna.png",
    "WLF": "/countries/WLF.png",
    "Samoa": "/countries/Samoa.png",
    "WSM": "/countries/WSM.png",
    "Yemen": "/countries/Yemen.png",
    "YEM": "/countries/YEM.png",
    "South Africa": "/countries/South Africa.png",
    "ZAF": "/countries/ZAF.png",
    "Zambia": "/countries/Zambia.png",
    "ZMB": "/countries/ZMB.png",
    "Zimbabwe": "/countries/Zimbabwe.png",
    "ZWE": "/countries/ZWE.png",
};

/**
 * Returns the public URL path for a country flag if available.
 * @param {string} country - Full name OR alpha-3 code (e.g., "Pakistan" or "PAK")
 * @returns {string|null} - Public URL path or null
 */
export function getCountryFlag(country) {
    return countryFlagMap[country] || null;
}